/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEffect, useState } from 'react';
import GenericElement from '../Utils/GenericElement';
import loadJsonData from '../Utils/loadJsonData';
import LocalStorage from 'Helpers/MFXLocalStorage';
import URLS from '../Utils/URLs.API';
import Loading from 'Components/Lib/Elements/Loading';
import Editbutton from '../Elements/Editbutton';
import loadJsonPut from '../Utils/jsonPut';
import loadJsonDelete from '../Utils/jsonDelete';
import CreateDocument, { CreateDocumentProvider } from './CreateDocument';
import ModalPopup from '../Common/ModalPopup';
import Addbutton from '../Elements/Addbutton';

export function BasketPositionsView(props: any) {
    const [data, setData] = useState(null as any);
    const [loading, setLoading] = useState(true);
    const [createActive, setCreateActive] = useState(false);
    const [tanIndex, setTanIndex] = useState(false);
    const customerNumber = LocalStorage?.getTabData()?.primaryType === 'customer' ? LocalStorage?.getTabData().primaryId : 0;

    useEffect(() => {
        loadData();
    }, []);

    function loadData() {
        setLoading(true);
        loadJsonData('/' + LocalStorage.getConnectionKey() + URLS.GetBasketIndex + '?Data.CustomerNumber=' + customerNumber).then((data: any) => {
            if (data.Meta.Success && data.Data && data.Data.TanIndex) {
                setTanIndex(data.Data.TanIndex);
                loadJsonData('/' + LocalStorage.getConnectionKey() + URLS.GetBasketPositions + '?Data.TanIndex=' + data.Data.TanIndex).then((data: any) => {
                    if (data.Meta.Success && data.Data && data.Data.BasketData) {
                        setData(
                            data.Data.BasketData.map(d => ({
                                ...d,
                                SalesPriceTotalExclusive: d.SalesPriceExclusive * d.SalesQuantity,
                                SalesPriceTotalInclusive: d.SalesPriceInclusive * d.SalesQuantity,
                            }))
                        );
                    }
                    setLoading(false);
                });
            } else {
                setData(null);
                setTanIndex(false);
                setLoading(false);
            }
        });
    }

    function onChange(id, key, newValue) {
        var oldValue = data[id][key];
        data[id][key] = newValue;
        console.log(key);
        switch (key) {
            case 'GrossPriceExclusive':
            case 'SalesPriceExclusive':
                data[id].Discount = (1 - data[id].SalesPriceExclusive / data[id].GrossPriceExclusive) * 100;
                break;
            case 'GrossPriceInclusive':
                data[id].GrossPriceExclusive = data[id].GrossPriceInclusive / (1 + data[id].VAT / 100);
                data[id].Discount = (1 - data[id].SalesPriceExclusive / data[id].GrossPriceExclusive) * 100;
                break;
            case 'SalesPriceInclusive':
                data[id].SalesPriceExclusive = data[id].SalesPriceInclusive / (1 + data[id].VAT / 100);
                data[id].Discount = (1 - data[id].SalesPriceExclusive / data[id].GrossPriceExclusive) * 100;
                break;
            case 'SalesQuantity':
                data[id].QuantityInStockQuantityUnit = data[id].SalesQuantity * (data[id].Factor ?? 1);
                break;
            case 'QuantityInStockQuantityUnit':
                data[id].SalesQuantity = data[id].QuantityInStockQuantityUnit / (data[id].Factor ?? 1);
                break;
        }
        if (!data[id].GrossPriceExclusive) {
            data[id].Discount = 0;
        }
        data[id].SalesPriceExclusive = key === 'SalesPriceExclusive' ? (data[id].GrossPriceExclusive || data[id].SalesPriceExclusive) * (1 - data[id].Discount / 100) || null : (data[id].GrossPriceExclusive || data[id].SalesPriceExclusive) * (1 - data[id].Discount / 100);
        data[id].SalesPriceInclusive = key === 'SalesPriceInclusive' ? data[id].SalesPriceExclusive * (1 + data[id].VAT / 100) || null : data[id].SalesPriceExclusive * (1 + data[id].VAT / 100);
        data[id].GrossPriceInclusive = key === 'GrossPriceInclusive' ? data[id].GrossPriceExclusive * (1 + data[id].VAT / 100) || null : data[id].GrossPriceExclusive * (1 + data[id].VAT / 100);
        data[id].SalesPriceTotalExclusive = data[id].SalesPriceExclusive * data[id].SalesQuantity;
        data[id].SalesPriceTotalInclusive = data[id].SalesPriceInclusive * data[id].SalesQuantity;

        setData(data.map(o => ({ ...o })));
        if (key === 'SalesQuantityUnit') save(new Event(''));
    }

    function save(e, loading = true) {
        if(loading)
            setLoading(true);
        e.preventDefault();
        var body = {
            UpdateData: {
                CustomerNumber: customerNumber,
                BasketData: data.map(d => ({ ...d, ManualEditDiscount: true })),
            },
        };
        loadJsonPut('/' + LocalStorage.getConnectionKey() + URLS.UpdateBasket, body).then((data: any) => {
            if(loading)
                loadData();
        });
    }

    function remove(e, posID) {
        setLoading(true);
        e.preventDefault();
        loadJsonDelete('/' + LocalStorage.getConnectionKey() + URLS.RemoveFromBasket + '?Data.BasketPositionIndex=' + posID).then((data: any) => {
            loadData();
        });
    }

    return (
        <>
            {loading && <Loading />}
            {data && !loading && (
                <>
                    <div className="mfx-action-buttons">
                        <Editbutton saveChangeHandler={e => save(e)} />
                    </div>
                    <div>
                        <div className="mfx-table-container">
                            <table className="mfx-table" style={{ width: 'unset', tableLayout: 'auto' }}>
                                <>
                                    <tr>
                                        {props.designer?.TableElements &&
                                            props.designer?.TableElements[0] &&
                                            Object.entries(props.designer.TableElements[0]).map((designer: any, idx) => {
                                                return <th>{window.Dictionary.getTranslation(designer[1].Label)}</th>;
                                            })}
                                        <th></th>
                                    </tr>
                                    {data.map((d, id) => {
                                        return (
                                            <tr>
                                                {props.designer?.TableElements &&
                                                    props.designer?.TableElements[0] &&
                                                    Object.entries(props.designer.TableElements[0]).map((designer: any, idx) => {
                                                        var value = d[designer[1].Key];
                                                        return (
                                                            <td className='basket-td'>
                                                                <GenericElement customId={d?.ItemNumber} customData={value} designData={{ ...designer[1] }} key={id + idx} index={idx} onChangeGenericElement={e => onChange(id, e.designData.Key, e.newValue)} />
                                                            </td>
                                                        );
                                                    })}
                                                <td>
                                                    <button style={{ width: '100%' }} onClick={e => remove(e, d.Index ?? 0)}>
                                                        {window.Dictionary.getTranslation(64)}
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </>
                            </table>
                        </div>
                        <button className="mfx-button right" onClick={() => {save(new Event(''),false); setCreateActive(true);}}>
                            {window.Dictionary.getTranslation(561)}
                        </button>
                    </div>
                    {createActive && (
                        <ModalPopup modalClass="mfx-add-modal">
                            <CreateDocumentProvider customer={customerNumber} tanIndex={tanIndex} viewName={'DocumentAddView'} layoutName={'default'}>
                                <div className="mfx-action-buttons">
                                    <Addbutton
                                        disableChangeHandler={() => {
                                            setCreateActive(false);
                                        }}
                                        disableMode={createActive}
                                        save={false}
                                    />
                                </div>
                            </CreateDocumentProvider>
                        </ModalPopup>
                    )}
                </>
            )}
            {!data && !loading && <div className='no-data'>{window.Dictionary.getTranslation(5484)}</div>}
        </>
    );
}
